export default "__VITE_ASSET__Bf_dibdX__"